import { VApp } from 'vuetify/lib/components/VApp';
import { VContent } from 'vuetify/lib/components/VContent';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,[_c('div',{attrs:{"id":"bg"}}),_c('Snack'),_c('Animations'),_c('Bar'),_c('div',{attrs:{"id":"barspacer"}}),_c(VContent,{attrs:{"id":"content"}},[_c(VImg,{staticClass:"curtain",attrs:{"src":"/curtain.svg","id":"leftc"}}),_c(VImg,{staticClass:"curtain",attrs:{"src":"/curtain.svg","id":"rightc"}}),_c(VFadeTransition,{attrs:{"mode":"out-in","duration":"150"}},[_c('keep-alive',{attrs:{"include":"home"}},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }